export enum PAGE {
    HOME = "Home",
    CHECKOUT = "Checkout",
    DONE = "Done",
    COMMUNITYBLOG = "Community Blog"
};
export type AppFlow = { page: PAGE };
